import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/system';

import LinkIcon from '@mui/icons-material/Link';

import { brandLogo, UNBRANDED_BG, UNBRANDED_COLOR } from '../common/brands';

// The mark for a resolved profile's platform.
export default function PlatformIcon({ platform, size }) {
  // The brand's own mark wins; it carries its colors and ignores the badge one.
  const logo = brandLogo(platform);
  if (logo) {
    return (
      <img
        src={logo}
        alt=""
        width={size}
        height={size}
        style={{ display: 'block', objectFit: 'contain' }}
      />
    );
  }

  // A generic website, or a brand we carry no mark for.
  return (
    <Box sx={{
      width: size,
      height: size,
      borderRadius: '4px',
      background: UNBRANDED_BG,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <LinkIcon sx={{ fontSize: Math.round(size * 0.66), color: UNBRANDED_COLOR, display: 'block' }} />
    </Box>
  );
}

PlatformIcon.propTypes = {
  platform: PropTypes.string,
  size: PropTypes.number,
};

PlatformIcon.defaultProps = {
  platform: 'web',
  size: 16,
};
